<template>
  <div v-if="price" class="price-display">

    <div v-if="priceIsDiscounted" class="ribbon"><span>special</span></div>
<!--    <div v-else-if="priceIncludesTrialPeriod" class="ribbon"><span>free trial</span></div>-->
    <div v-else-if="price.product === 'prod_family-membership'" class="ribbon"><span>4 members</span></div>

    <div v-if="priceIsDiscounted">
      <span class="large-price">{{toCurrencyString(discountedMonthlyUnitAmount)}}</span>/month<br>
      <div class="discount-msg" v-html="discountMessageHtml"></div>
      <div v-html="billedAtMessageHtml"></div>
      <div class="cancel-anytime-msg">Cancel anytime</div>
    </div>

    <div v-else>
      <span class="large-price" :class="{ 'line-through': priceIncludesTrialPeriod, }">{{toCurrencyString(monthlyUnitAmount)}}</span>/month<br>
      <div v-if="priceIncludesTrialPeriod" class="free-trial-msg">{{trialPeriodMessage}}</div>
      <div v-html="billedAtMessageHtml"></div>
      <div class="cancel-anytime-msg">Cancel anytime</div>
    </div>

<!--    <hr>-->
<!--    <pre>{{JSON.stringify(price, null, 2)}}</pre>-->

  </div>
</template>


<script>
export default {
  name: "PriceDisplay",
  props: ['price'],
  data() {
    return {
    }
  },
  computed: {
    priceIsDiscounted() {
      return !!(this.price.metadata?.coupon_percent_off || this.price.metadata?.coupon_amount_off);
    },

    priceIncludesTrialPeriod() {
      return !!this.price.metadata?.trial_period_days;
    },

    discountedUnitAmount() {
      const newPriceFactor = this.price.metadata?.coupon_percent_off? (100 - this.price.metadata.coupon_percent_off) / 100 : 1.0;
      const newPriceAdjustment = this.price.metadata?.coupon_amount_off? -this.price.metadata.coupon_amount_off : 0.0;
      return ((this.price.unit_amount * newPriceFactor) + newPriceAdjustment);
    },
    monthlyUnitAmount() {

      // convert to monthly
      switch (this.price.recurring?.interval) {
        case 'day':
          return (this.price.unit_amount * 30.4);

        case 'week':
          return (this.price.unit_amount * 4.33);

        case 'month':
          return (this.price.unit_amount);

        case 'year':
          return (this.price.unit_amount / 12);
      }

      // if this isn't a recurring payment, it's literally zero units per month
      return 0;
    },

    discountedMonthlyUnitAmount() {
      // convert to monthly
      switch (this.price.recurring?.interval) {
        case 'day':
          return (this.discountedUnitAmount * 30.4);

        case 'week':
          return (this.discountedUnitAmount * 4.33);

        case 'month':
          return (this.discountedUnitAmount);

        case 'year':
          return (this.discountedUnitAmount / 12);
      }

      return 0;
    },

    trialPeriodMessage() {
      if ( this.price.metadata?.trial_period_days ) {
        return `${this.price.metadata.trial_period_days}-day trial for $0`;
      }
      return null;
    },

    discountMessageHtml() {
      return (
          (this.price.metadata.coupon_percent_off && !this.price.metadata?.coupon_amount_off) ?
              this.percentOffMessageHtml :
              this.amountOffMessageHtml
      );
    },

    amountOffMessageHtml() {
      if ( this.price.recurring.interval && (this.discountedUnitAmount !== this.price.unit_amount) ) {
        const capitalizedInterval = this.price.recurring.interval.replace(/^./, char => char.toUpperCase())
        return `First ${capitalizedInterval} <span style="white-space: nowrap;">${this.toCurrencyString(this.discountedUnitAmount)} +tax</span>`;
      }
      return null;
    },

    percentOffMessageHtml() {
      if ( this.price.recurring.interval && (this.discountedUnitAmount !== this.price.unit_amount) ) {
        const capitalizedInterval = this.price.recurring.interval.replace(/^./, char => char.toUpperCase())
        const percentOff = (100 - ((this.discountedUnitAmount / this.price.unit_amount) * 100)).toFixed();
        return `${percentOff}% Off Your First ${capitalizedInterval}<br><span style="white-space: nowrap;"><i>(${this.toCurrencyString(this.discountedUnitAmount)} +tax)</i></span>`;
      }
      return null;
    },

    billedAtMessageHtml() {
      if ( this.price.recurring ) {
        const thenText = (this.priceIncludesTrialPeriod || this.priceIsDiscounted)? 'Then ' : '';
        const regularPriceText = this.priceIsDiscounted? ' Our Regular Price of ' : ' ';
        return `${thenText}Billed at${regularPriceText}<span style="white-space: nowrap;">${this.toCurrencyString(this.price.unit_amount)}/${this.price.recurring.interval} +tax</span>`;
      }
      return null;
    },
    discountedBilledAtMessage() {
      if ( this.price.recurring ) {
        const thenText = this.price.metadata?.trial_period_days? 'Then ' : '';
        return `${thenText}Billed at ${this.toCurrencyString(this.price.unit_amount)}/${this.price.recurring.interval} +tax`
      }
      return null;
    }
  },

  methods: {
    toCurrencyString(_amount) {
      return `$${(_amount/100).toFixed(2)}`;
    },
  }

}
</script>


<style scoped>

.price-display {

  border-style: solid;
  border-color: var(--mol-color-gold);
  border-width: 1px;
  padding: 10px;

  position: relative;
  text-align: center;


  .discount-msg, .free-trial-msg {
    color: var(--mol-color-red-carpet);
    font-weight: bold;
    font-size: 20px;
  }

  .large-price {
    font-size: 60px;

    &.line-through {
      text-decoration-line: line-through;
      text-decoration-color: var(--mol-color-red-carpet);
    }
  }

  .cancel-anytime-msg {
    margin-top: 0.3em;
  }

  pre {
    text-align: left;
    font-size: 5px;
  }
}

.ribbon {
  position: absolute;
  left: -5px; top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px; height: 75px;
  text-align: right;
}
.ribbon span {
  font-size: 10px;
  font-weight: bold;
  color: var(--bs-body-bg);
  text-transform: uppercase;
  text-align: center;
  line-height: 20px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  width: 100px;
  display: block;
  background: var(--mol-color-gold-faded);
  background: linear-gradient(var(--mol-color-gold-faded) 0%, var(--mol-color-gold) 100%);
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 19px; left: -21px;
}
.ribbon span::before {
  content: "";
  position: absolute; left: 0px; top: 100%;
  z-index: -1;
  border-left: 3px solid var(--mol-color-gold);
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid var(--mol-color-gold);
}
.ribbon span::after {
  content: "";
  position: absolute; right: 0px; top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-right: 3px solid var(--mol-color-gold);
  border-bottom: 3px solid transparent;
  border-top: 3px solid var(--mol-color-gold);
}

</style>